import React, { useState } from 'react'
import axios from '../utils/axios'

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

//firebase
import { confirmPasswordReset } from 'firebase/auth'
import { dataBase } from '../utils/FirebaseConfig'


//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye,faEyeSlash,faXmark } from '@fortawesome/free-solid-svg-icons';

import { useLocation } from 'react-router-dom'

//form
import {yupResolver} from "@hookform/resolvers/yup"
import {useForm} from "react-hook-form"
import * as yup from "yup"

export const ResetPassword = () => {

    const [show, setShow] = useState(false)
    const [showIcon, setShowIcon] = useState(false)

    const schema = yup.object().shape({
        password:yup.string().min(7).max(20).required(),
        //This is used to compare a passwaor and confirm password
        confirmPassword:yup.string().oneOf([yup.ref("password"),null]).required(),
    })

    const {register, handleSubmit, reset, formState: { errors }} = useForm({
        resolver: yupResolver(schema)
    });

    const UrlParams = ()=>{
        return new URLSearchParams(useLocation().search)
    }

    const params = UrlParams()
    var oobCode = params.get('oobCode')
    var resetEmail = params.get('email') 
    // console.log(oobCode)

    const onSubmit = async (data,e) => {
        e.preventDefault()
        let password = data.password;
        console.log(oobCode)
        try {
            if( password.match(/[!@#$%^&*]/) != null && password.match(/.{8,}/) != null &&  password.match(/[0-9]/) != null && password.match(/[A-Z]/) != null ){
                console.log(oobCode)
                await confirmPasswordReset(dataBase,oobCode.toString(),data.password)
                    .then(async()=>{
                        await axios.post("/reset/update",
                            {
                                Email:resetEmail,
                                password:data.password
                            },{
                                headers:{"Content-Type": "application/json"},
                                withCredentials:true,
                            }
                        ).then((res)=>{

                            setShow(!show)

                            setTimeout(()=>{
                               window.location.href="/login"
                            },5000)
                            
                            console.log("Password Reset successfully")
                            toast.success("Password Reset successfully",{position:'top-right'})
                        
                        })
                        
                            
                        console.log("hi")
                        
                    }).catch( error =>{
                            console.log(error.message)
                            console.log(error)
                            toast.error(error.message,{position:"top-right"})
                        } )
            }else{
                console.log("invalid password")
                toast.error(<div>Password must be:<br/> 1) Between 8-30 characters,<br/> 2) At least one upper and lower case letter,<br/> 3) At least one number,<br/> 4) At least one special character</div>,{position:"top-right"})
            }
        } catch (error) {
            console.log(error.message)
            toast.error(error.message,{position:"top-right"})
        }
    }
    
    const handlSshowHide =()=>{
        setShowIcon(!showIcon)
      }

  return (
    <div>
        {/* <!-- section start --> */}
        <section className="login-section section-b-space">
            <a href="index.html" className="logo-auth">Coinstirs</a>
            <div className="row m-0">
                <div className="col-lg-7 d-lg-inline-block d-none p-0">
                    <div className="login-animation">
                        <img src={require("../../assets/svg/home/log3.svg").default} data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"
                            className="img-fluid img-base aos-animate w-600" alt=""/>
                        <img  src={require("../../assets/svg/home/log1.svg").default} data-aos="zoom-in-up" data-aos-duration="1000"
                            data-aos-delay="1000" className="img-fluid img-light aos-animate w-600" alt=""/>
                        <div className="img-face" data-aos-delay="2500" data-aos="flip-left" data-aos-easing="ease-out-cubic"
                            data-aos-duration="1000"> <img  src={require("../../assets/svg/home/log.svg").default} className="w-450 img-fluid aos-animate" alt=""/></div>
                    </div>
                </div>
                <div className="col-xxl-4 col-lg-5 ms-auto p-0">
                    <div className="login-box mt-sm-0">
                        <div>
                            <h2><span>Reset password</span></h2>
                            {/* <p>When you provide your email address, we'll send you a message with information on how to
                                reset.</p> */}
                            {
                                !show ? (
                                    <form className="auth-form" onSubmit={handleSubmit(onSubmit)} >
                                        <div className="mb-3 form-group pos-rel">
                                            {/* <i class="iconsax" data-icon="mail"></i> */}
                                            <label htmlFor="emailid" className="form-label">Password</label>
                                            <input {...register("password")} type={showIcon ? "text" : "password"} placeholder="Password" className="form-control" id="emailid"/>
                                            {errors.password &&  <p style={{fontSize:'12px',color:'red'}}>Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number</p>}
                                            {/* <span className="eye"><i className="fa-regular fa-eye-slash"></i></span> */}
                                            <div className='log-icon'>
                                                <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({password:""})}} />
                                                {
                                                    showIcon ? (
                                                        <FontAwesomeIcon icon={faEye}  id='show_hide' onClick={handlSshowHide}  />
                                                    ) : (
                                                        <FontAwesomeIcon icon={faEyeSlash}  id='show_hide' onClick={handlSshowHide}  />
                                                    )
                                                }
                                            </div>
                                            <div className='pos-rel'>
                                                <label htmlFor="emailid" className="form-label">Confirm Password</label>
                                                <input type="password" {...register("confirmPassword")} placeholder="Confirm Password" className="form-control" id="emailid"/>
                                                {errors.confirmPassword && <p style={{fontSize:'12px',color:'red'}}>Password is not matched</p>}
                                                {/* <span className="eye"><i className="fa-regular fa-eye-slash"></i></span> */}
                                                <div className='log-icon'>
                                                    <FontAwesomeIcon clas icon={faXmark} onClick={()=>{reset({confirmPassword:""})}} />
                                                </div>
                                            </div>
                                            </div>
                                        <button data-cursor="pointer"
                                            className="btn-solid btn-absolute text-center mt-3">Reset
                                            Password</button>
                                    </form>
                                ) :(
                                    <div>
                                        <h3>Forgot Password link send successfully, Check your Email</h3>
                                        <a href="/login">Back to Login ?</a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- section end --> */}
    </div>
  )
}
